export default __webpack_public_path__ + "static/media/jne.d31fde2d.png";